import { _ErrorBus } from './business/ErrorBus';

const ErrorBus = new _ErrorBus();

export { ErrorBus };
